<script>
  import { setClient } from 'helpers/client'

  export let client

  setClient(client)
</script>

<slot />
